import React from "react";
import { Image } from "react-bootstrap";
import QRCode from "react-qr-code";

const TableTentCardComponent = (props) => {
  return (
    <div key={props.keysData}>
      {/* className="col mb-5" */}
      <div
        className="card p-2 text-center rounded-0"
        style={{ backgroundColor: "#EF3F23" }}
      >
        <div
          className="bg-white border-dark"
          style={{
            borderRadius: "0% 0% 250vh 250vh/0% 0% 120vh 120vh",
            transform: "rotate(180deg)",
          }}
        >
          <div className="card-header bg-transparent p-0 border-0 mt-2 mb-0">
            <Image
              className="img-fluid rounded border shadow-sm"
              alt="Restaurant Logo"
              title="Restaurant Logo"
              src={props?.logo}
              style={{ width: "80px", height: "40px" }}
            />
          </div>
          <div className="card-body text-center py-2">
            <div className="col-12 mb-3">
              <p className="f9-700">{props?.name}</p>
            </div>
            <div>
              <QRCode
                bgColor="#FFFFFF"
                fgColor="#000000"
                size={props?.sizeData || 150}
                level="Q"
                value={
                  typeof props.qrData === "object"
                    ? JSON.stringify(props.qrData)
                    : props.qrData
                    ? props.qrData
                    : JSON.stringify({ status: false })
                }
              />
            </div>
            <div className="col-12 mt-3">
              <p className="f13-700">
                {props.qrData?.type !== undefined &&
                props.qrData?.type !== null &&
                props.qrData?.type === "table_management"
                  ? "Table Number - "
                  : "Seat Number - "}
                <span className="f13-700">
                  {props.qrData?.type !== undefined &&
                  props.qrData?.type !== null &&
                  props.qrData?.type === "table_management"
                    ? props.qrData?.table_number
                    : props.qrData?.seat_number}
                </span>
              </p>
            </div>
          </div>
          <div className="card-footer bg-transparent border-0 text-center p-0">
            <hr className="w-75 mt-0 mb-2" />
            <p className="col-12 f9-500">Scan via Amealio App</p>
            <Image
              className="img-fluid mb-2"
              style={{ width: "50px", height: "15px" }}
              alt="Amealio Logo"
              title="Amealio Logo"
              src={`https://amealia.s3.amazonaws.com/logo.png`}
            />
          </div>
        </div>
      </div>
      <div
        style={{ border: "none", borderTop: "1px dashed #f00", height: "1px" }}
      ></div>
      <div
        className="card p-2 text-center rounded-0"
        style={{ backgroundColor: "#EF3F23" }}
      >
        <div
          className="bg-white border-dark"
          style={{ borderRadius: "0% 0% 250vh 250vh/0% 0% 120vh 120vh" }}
        >
          <div className="card-header bg-transparent p-0 border-0 mt-2 mb-0">
            <Image
              className="img-fluid rounded border shadow-sm"
              alt="Restaurant Logo"
              title="Restaurant Logo"
              src={props?.logo}
              style={{ width: "80px", height: "40px" }}
            />
          </div>
          <div className="card-body text-center py-2">
            <div className="col-12 mb-3">
              <p className="f9-700">{props?.name}</p>
            </div>
            <div>
              <QRCode
                bgColor="#FFFFFF"
                fgColor="#000000"
                size={props?.sizeData || 150}
                level="H"
                value={
                  typeof props.qrData === "object"
                    ? JSON.stringify(props.qrData)
                    : props.qrData
                    ? props.qrData
                    : JSON.stringify({ status: false })
                }
              />
            </div>
            <div className="col-12 mt-3">
              <p className="f13-700">
                {props.qrData?.type !== undefined &&
                props.qrData?.type !== null &&
                props.qrData?.type === "table_management"
                  ? "Table Number - "
                  : "Seat Number - "}
                <span className="f13-700">
                  {props.qrData?.type !== undefined &&
                  props.qrData?.type !== null &&
                  props.qrData?.type === "table_management"
                    ? props.qrData?.table_number
                    : props.qrData?.seat_number}
                </span>
              </p>
            </div>
          </div>
          <div className="card-footer bg-transparent border-0 text-center p-0">
            <hr className="w-75 mt-0 mb-2" />
            <p className="col-12 f9-500">Scan via Amealio App</p>
            <Image
              className="img-fluid mb-2"
              style={{ width: "50px", height: "15px" }}
              alt="Amealio Logo"
              title="Amealio Logo"
              src={`https://amealia.s3.amazonaws.com/logo.png`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableTentCardComponent;
